import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AuthGuard, CmsConfig, I18nModule, provideConfig} from "@spartacus/core";
import {InvoiceDetailsComponent} from "./invoice-details.component";
import {PageTitle} from "../../store-front/misc/page-title/page-title.component";
import {FormModule} from "@spartacus/organization/administration/components";
import {CustomBannerModule} from "../../store-front/misc/cms-components/banner/banner.module";
import {RouterModule} from "@angular/router";
import {InvoicesModule} from "../invoices.module";
import {LocalLoaderComponent} from "../../../../components/loader/local-loader/local-loader.component";

@NgModule({
  declarations: [InvoiceDetailsComponent],
    imports: [
        CommonModule,
        PageTitle,
        I18nModule,
        FormModule,
        RouterModule,
        CustomBannerModule,
        InvoicesModule,
        LocalLoaderComponent,
    ],
  providers: [
    provideConfig(<CmsConfig >{
      cmsComponents: {
        InvoiceDetailsPageComponent: {
          component: InvoiceDetailsComponent,
          guards: [AuthGuard],
        }
      },
    })
  ]
})
export class InvoiceDetailsModule { }
